import Moment from "react-moment";
import { comum } from "../../../styles/Themes/light";
import { IconAccept, IconAdvanceMoney, IconInProgress, IconWrong } from "../../icons";
import { useAuth } from "../../../contexts/UserContext";
import { Pendency } from "../BlocoPendencias/styles";

export default function CardListaPendenciaPagamento({
    pendencia,
    resolvePendencia
}: {
    pendencia: any;
    resolvePendencia: () => void;
}) {

    const { user } = useAuth();

    const defPendencias: any = {
        marjoracao: 'Majoração',
        reembolso: 'Reembolso',
        adiantamento: 'Adiantamento',
    }

    return (
        <Pendency>
            <div className="header">
                <div className="icon-title">
                    <IconAdvanceMoney color={comum.colors.primaryRed400}/>
                    {defPendencias[pendencia.tipo]}
                </div>

                <div className="date-status">
                    <div className="date">
                        <Moment locale='pt-br' fromNow>{pendencia.criado}</Moment>
                    </div>
                    {
                        pendencia.resolvida !== 'sim'
                            ? pendencia.destino === 'operador' && user.profile !== 'comum'
                                ?
                                    <div 
                                        className="status resolve"
                                        onClick={resolvePendencia}
                                    >
                                        Responder
                                    </div>
                                :   <div className="status waiting">
                                        <IconInProgress />
                                        Aguardando
                                    </div>
                            : pendencia.aceita === 'sim'
                                ?   <div className="status success">
                                        <IconAccept />
                                        Aceita
                                    </div>
                                :   <div className="status refuse">
                                        <IconWrong />
                                        Recusada
                                    </div>
                    }                                                                
                </div>

            </div>


            <div className="money">
                {
                    pendencia.valor.toString().includes('.')
                        ? pendencia.valor.toString().replace('.', ',')
                        : `R$ ${pendencia.valor},00`
                }
                <span>Valor adiantado</span>
            </div>

            <div className="info">
                {pendencia.descricao}
            </div>


        </Pendency>
    );
}